import Vue from 'vue'
import Router from 'vue-router';
import DeclarePost from '@/views/pages-personal/index-per/declare-post/index';
import DeclareCheckInst from '@/views/pages-institution/user-inst/declare-check-inst/index.vue';
import PanelDetail from '@/views/pages-institution/user-inst/interview-physical-inspection-publicity/index.vue';

Vue.use(Router);
// 关于Vue Router报错,路由跳转报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

// 人才申报端单位
const institutionRoutes = {
  path: '/institution',
  component: () => import('../views/pages-institution/index.vue'),
  children: [
    {
      path: '/institution/index',
      component: () => import('../views/pages-institution/app-index/index.vue')
    },
    {
      path: '/institution/user',
      component: () => import('../views/pages-institution/user-inst/index.vue'),
      children: [
        {
          path: '/institution/user-info', // 单位信息
          component: () =>
            import(
              '../views/pages-institution/user-inst/user-info-inst/index.vue'
            )
        },
        {
          path: '/institution/post-list', // 人才岗位管理
          component: () =>
            import(
              '../views/pages-institution/user-inst/post-list-inst/index.vue'
            )
        },
        {
          path: '/institution/post-list/post-detail', // 人才岗位详情
          component: DeclarePost
        },
        {
          path: '/institution/post-list/post-apply', // 人才岗位申请
          component: () =>
            import(
              '../views/pages-institution/user-inst/post-apply-inst/index.vue'
            )
        },
        {
          path: '/institution/declare-list', // 人才申报信息审核
          component: () =>
            import(
              '../views/pages-institution/user-inst/declare-list-inst/index.vue'
            )
        },
        {
          path: '/institution/declare-list/declare-check', // 人才申报审核
          component: DeclareCheckInst
        },
        {
          path: '/institution/declare-files-list', // 人才申报材料审核
          component: () =>
            import(
              '../views/pages-institution/user-inst/declare-files-list-inst/index.vue'
            )
        },
        {
          path: '/institution/declare-files-list/declare-check-file', // 人才申报审核
          component: DeclareCheckInst
        },
        {
          path: '/institution/inspect-list', // 人才考察管理
          component: () =>
            import(
              '../views/pages-institution/user-inst/inspect-list-inst/index.vue'
            )
        },
        {
          path: '/institution/appeal-list', // 人才申诉管理
          component: () =>
            import(
              '../views/pages-institution/user-inst/appeal-list-inst/index.vue'
            )
        },
        {
          path: '/institution/appeal-list/appeal-check', // 人才申诉审核
          component: () =>
            import(
              '../views/pages-institution/user-inst/appeal-check-inst/index.vue'
            )
        },
        {
          path: '/institution/progress', // 进度查询导出
          component: () =>
            import(
              '../views/pages-institution/user-inst/progress-inst/index.vue'
            )
        },
        {
          path: '/institution/employed-list', // 已录用人才管理
          component: () =>
            import(
              '../views/pages-institution/user-inst/employed-list-inst/index.vue'
            )
        },
        {
          path: '/institution/employed-list/four-detail', // 已录用人才管理
          component: PanelDetail
        },
        {
          path: '/institution/message-list', // 我的消息
          component: () =>
            import(
              '../views/pages-institution/user-inst/message-list-inst/index.vue'
            )
        },
        {
          path: '/institution/interview-list', // 初面管理
          component: () =>
            import(
              '../views/pages-institution/user-inst/interview-list-inst/index.vue'
            )
        },
        {
          path: '/institution/interview-list/four-detail', // 初面管理详情
          component: PanelDetail
        },
        {
          path: '/institution/interview-two-list', // 面试管理
          component: () =>
            import(
              '../views/pages-institution/user-inst/interview-two-list-inst/index.vue'
            )
        },
        {
          path: '/institution/interview-two-list/four-detail', // 面试管理详情
          component: PanelDetail
        },
        {
          path: '/institution/talent-transfer-list', // 人才调剂
          component: () =>
            import(
              '../views/pages-institution/user-inst/talent-transfer-inst/index.vue'
            )
        },
        {
          path: '/institution/talent-transfer-list/declare-check-inst', // 人才调剂详情
          component: PanelDetail
        },
        {
          path: '/institution/talent-transfer-lists/four-detail', // 人才调剂详情
          component: PanelDetail
        },
        {
          path: '/institution/physical-list', // 人才体检考察管理
          component: () =>
            import(
              '../views/pages-institution/user-inst/physical-list-inst/index.vue'
            )
        },
        {
          path: '/institution/physical-list/four-detail', // 人才体检考察管理详情
          component: PanelDetail
        },
        {
          path: '/institution/four-detail', // 面试，体检，考察，结果公示的详情页
          component: PanelDetail
        }
      ]
    },
    {
      path: '/institution/dh-review/innovation-list',
      component: () => import('../views/pages-dh/dh-review-institution/innovation-list-inst/index.vue')
    },
    {
      path: '/institution/dh-review/innovation-check',
      component: () => import('../views/pages-dh/dh-review-institution/innovation-check-inst/index.vue'),
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/institution/dh-review/startup-list',
      component: () => import('../views/pages-dh/dh-review-institution/startup-list-inst/index.vue')
    },
    {
      path: '/institution/dh-review/startup-check',
      component: () => import('../views/pages-dh/dh-review-institution/startup-check-inst/index.vue'),
      meta: {
        keepAlive: true
      }
    },
    // 拔尖人才审核列表路由配置
    {
      path: '/institution/bajian-review-list',
      component: () => import('../views/pages-bajian/bajian-review/review-list/index.vue'),
    },
    {
      path: '/institution/bajian-review-check',
      component: () => import('../views/pages-bajian/bajian-review/review-check/index.vue'),
    },
    // 海外审核列表路由配置
    {
      path: '/institution/overseas-review-list',
      component: () => import('../views/pages-overseas/overseas-review/review-list/index.vue'),
    },
    {
      path: '/institution/overseas-review-check',
      component: () => import('../views/pages-overseas/overseas-review/review-check/index.vue'),
    },
    //生物医药
     {
      path: '/institution/biology-medicine-list',
      component: () => import('../views/pages-biology/biology-medicine/index.vue'),
    },
    {
      path: '/institution/applyExamine',
      component: () => import('../views/pages-biology/biology-apply-personal/examine.vue'),  //组件仅用于跳转
    },
    //商贸物流人才
    {
      path: '/institution/commerce-review-list',
      component: () => import('../views/pages-commerce/commerce-review/review-list/index.vue'),
    },
    {
      path: '/institution/commerce-review-check',
      component: () => import('../views/pages-commerce/commerce-review/review-check/index.vue'),
    },
    //金融人才
    {
      path: '/institution/financial-review-list',
      component: () => import('../views/pages-financial/financial-review/review-list/index.vue'),
    },
    {
      path: '/institution/financial-review-check',
      component: () => import('../views/pages-financial/financial-review/review-check/index.vue'),
    },
    //骨干人才
    {//发起申请
      path: '/institution/backbone-apply-detail',
      component: () => import('../views/pages-backbone/backbone-apply/backbone-detail/index.vue'),
    },{//申请查看详情
      path: '/institution/backbone-apply-checkDetail',
      component: () => import('../views/pages-backbone/backbone-apply/backbone-detail/detail.vue'),
    },
    {//申请记录
      path: '/institution/backbone-apply-list',
      component: () => import('../views/pages-backbone/backbone-apply/backbone-list/index.vue'),
    },{//申请审核
      path: '/institution/backbone-review-list',
      component: () => import('../views/pages-backbone/backbone-review/review-list/index.vue'),
    },{//申请审核详情
      path: '/institution/backbone-review-check',
      component: () => import('../views/pages-backbone/backbone-review/review-check/index.vue'),
    },
    {//入选人才
      path: '/institution/backbone-review-talent',
      component: () => import('../views/pages-backbone/backbone-review/review-talent/index.vue'),
    },
    {//入选人才详情
      path: '/institution/backbone-review-checkTalent',
      component: () => import('../views/pages-backbone/backbone-review/review-checkTalent/index.vue'),
    },
    //社会人才
    {
      path: '/institution/social-review-list',
      component: () => import('../views/pages-social/social-review/review-list/index.vue'),
    },
    {
      path: '/institution/social-review-check',
      component: () => import('../views/pages-social/social-review/review-check/index.vue'),
    },
     //海洋人才
     {
      path: '/institution/ocean-review-list',
      component: () => import('../views/pages-ocean/ocean-review/review-list/index.vue'),
    },
    {
      path: '/institution/ocean-review-check',
      component: () => import('../views/pages-ocean/ocean-review/review-check/index.vue'),
    },
    //教育人才
    {
      path: '/institution/education-review-list',
      component: () => import('../views/pages-education/education-review/review-list/index.vue'),
    },
    {
      path: '/institution/education-review-check',
      component: () => import('../views/pages-education/education-review/review-check/index.vue'),
    },
    //文旅创意人才
    {
      path: '/institution/culturalTourism-review-list',
      component: () => import('../views/pages-culturalTourism/culturalTourism-review/review-list/index.vue'),
    },
    {//文旅创意人才主管部门审核
      path: '/institution/culturalTourism-review-manager-list',
      component: () => import('../views/pages-culturalTourism/culturalTourism-review/review-list/managerIndex.vue'),
    },
    {
      path: '/institution/culturalTourism-review-check',
      component: () => import('../views/pages-culturalTourism/culturalTourism-review/review-check/index.vue'),
    },
    //卫生健康人才
    {
      path: '/institution/sanitationHealth-review-list',
      component: () => import('../views/pages-sanitationHealth/sanitationHealth-review/review-list/index.vue'),
    },
    {
      path: '/institution/sanitationHealth-review-check',
      component: () => import('../views/pages-sanitationHealth/sanitationHealth-review/review-check/index.vue'),
    },
    //金融人才证书补贴
    {
      path: '/institution/financialCertificate-review-list',
      component: () => import('../views/pages-financialCertificate/financialCertificate-review/review-list/index.vue'),
    },
    {
      path: '/institution/financialCertificate-review-check',
      component: () => import('../views/pages-financialCertificate/financialCertificate-review/review-check/index.vue'),
    },
  ]
};

// 人才申报端个人
const personalRoutes = {
  path: '/personal',
  component: () => import('../views/pages-personal/index.vue'),
  children: [
    {
      path: 'index',
      component: () => import('../views/pages-personal/app-index/index.vue'),
    },
    {
      path: '/personal',
      component: () => import('../views/pages-personal/index-per/index.vue'),
      children: [
        {
          path: '/personal/plan-publicity', // 项目公示
          component: () =>
            import('../views/pages-personal/index-per/plan-publicity/index.vue')
        },
        {
          path: '/personal/plan-publicity/plan-detail', // 项目公示详情
          component: () =>
            import('../views/pages-personal/index-per/plan-detail/index.vue')
        },
        {
          path: '/personal/talent-publicity', // 人才公示
          component: () =>
            import(
              '../views/pages-personal/index-per/talent-publicity/index.vue'
            )
        },
        {
          path: '/personal/talent-publicity/talent-detail', // 人才公示详情
          component: () =>
            import('../views/pages-personal/index-per/talent-detail/index.vue')
        },
        {
          path: '/personal/declare-list', //申报大厅（个人）
          component: () =>
            import('../views/pages-personal/index-per/declare-list/index.vue')
        },
        {
          path: '/personal/declare-list/declare-post', //申报大厅-岗位信息
          component: DeclarePost
        },
        {
          path: '/personal/declare-list/declare-form', //申报大厅-表单下载样式
          component: () =>
            import('../views/pages-personal/index-per/declare-form/index.vue')
        },
        {
          path: '/personal/declare-list/declare-apply', //申报大厅-在线申请
          component: () =>
            import('../views/pages-personal/index-per/declare-apply/index.vue')
        },
        {
          path: '/personal/appeal-detail', //申诉详情页面
          component: () =>
            import('../views/pages-personal/user-per/appeal-detail')
        },
        {
          path: '/personal/apply-detail', //申报详情页面
          component: () =>
            import('../views/pages-personal/user-per/apply-detail')
        },
        {
          path: '/personal/dh-apply-detail', //双百申报详情页面
          component: () =>
            import('../views/pages-personal/user-per/dh-apply-detail'),
          meta: {
            keepAlive: true
          }
        },
        {
          path: '/personal/bajian-apply-detail', //拔尖申报详情页面
          component: () =>
            import('../views/pages-personal/user-per/bajian-apply-detail'),
          meta: {
            keepAlive: true
          }
        },
        {
          path: '/personal/overseas-apply-detail', //海外申报详情页面
          component: () =>
            import('../views/pages-personal/user-per/overseas-apply-detail'),
          meta: {
            keepAlive: true
          }
        }
      ]
    },
    {
      path: '/user-personal',
      component: () => import('../views/pages-personal/user-per/index.vue'),
      children: [
        {
          path: '/personal/user-info',
          component: () =>
            import('../views/pages-personal/user-per/user-info/index.vue')
        }
      ]
    }
  ]
};

// 专家在线评审系统
const onlineReviewRoutes = {
  path: '/online-review',
  name: '专家在线评审系统',
  component: () => import('../views/pages-online-review/index.vue'),
  children: [
    {
      path: '/online-review/review-list',
      name: '在线评审列表',
      component: () => import('../views/pages-online-review/review-list/index.vue'),
      // meta: {
      //   keepAlive: true
      // }
    },
    {
      path: '/online-review/review-material',
      name: '技术/资料查看',
      component: () => import('../views/pages-online-review/review-material/index.vue'),
      meta: {
        keepAlive: false
      }
    },
    // 拔尖人才资料查看
    {
      path: '/online-review/bajian-review-material',
      name: '拔尖技术/资料查看',
      component: () => import('../views/pages-online-review/bajian-review-material/index.vue'),
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/online-review/review-result',
      name: '技术/答辩评审结果评定',
      component: () => import('../views/pages-online-review/review-result/index.vue'),
      // meta: {
      //   keepAlive: false
      // }
    },
    {
      path: '/online-review/review-user-info',
      name: '个人中心',
      component: () => import('../views/pages-online-review/review-user/index.vue'),
      // meta: {
      //   keepAlive: false
      // }
    },
    // 海外资料查看
    {
      path: '/online-review/overseas-review-material',
      name: '海外资料查看',
      component: () => import('../views/pages-online-review/overseas-review-material/index.vue'),
      meta: {
        keepAlive: false
      }
    },
    //生物医药资料查看
    {
      path: '/online-review/biology-review-material',
      name: '生物医药资料查看',
      component: () => import('../views/pages-online-review/biology-review-material/index.vue'),
      meta: {
        keepAlive: false
      }
    },
    //社会工作人才资料查看
    {
      path: '/online-review/social-review-material',
      name: '社会工作人才资料查看',
      component: () => import('../views/pages-online-review/social-review-material/index.vue'),
      meta: {
        keepAlive: false
      }
    },
    //商贸物流人才资料查看
    {
      path: '/online-review/commerce-review-material',
      name: '商贸物流人才资料查看',
      component: () => import('../views/pages-online-review/commerce-review-material/index.vue'),
      meta: {
        keepAlive: false
      }
    },
    //金融人才资料查看
    {
      path: '/online-review/financial-review-material',
      name: '金融人才资料查看',
      component: () => import('../views/pages-online-review/financial-review-material/index.vue'),
      meta: {
        keepAlive: false
      }
    },
    //骨干人才资料查看
    {
      path: '/online-review/backbone-review-material',
      name: '骨干人才资料查看',
      component: () => import('../views/pages-online-review/backbone-review-material/index.vue'),
      meta: {
        keepAlive: false
      }
    },
    //海洋人才资料查看
    {
      path: '/online-review/ocean-review-material',
      name: '海洋人才资料查看',
      component: () => import('../views/pages-online-review/ocean-review-material/index.vue'),
      meta: {
        keepAlive: false
      }
    },
    //教育人才资料查看
    {
      path: '/online-review/education-review-material',
      name: '教育人才资料查看',
      component: () => import('../views/pages-online-review/education-review-material/index.vue'),
      meta: {
        keepAlive: false
      }
    },
     //文旅创意人才资料查看
     {
      path: '/online-review/culturalTourism-review-material',
      name: '文旅创意人才资料查看',
      component: () => import('../views/pages-online-review/culturalTourism-review-material/index.vue'),
      meta: {
        keepAlive: false
      }
    },
    //卫生健康人才资料查看
    {
      path: '/online-review/sanitationHealth-review-material',
      name: '卫生健康人才资料查看',
      component: () => import('../views/pages-online-review/sanitationHealth-review-material/index.vue'),
      meta: {
        keepAlive: false
      }
    },
  ]
}

// 个人与企业关系建立
const individualBusinessRoutes = {
  path: '/individual-business',
  name: '个人与企业关系建立',
  component: () => import('../views/pages-individual-business/index.vue'),
  children: [
    {
      path: '/institution/individual-business/talent-manage',
      name: '人才管理',
      component: () => import('../views/pages-individual-business/talent-manage/index.vue')
    }
  ]
}

// h5移动端路由配置
const mobileRoutes = {
  path: '/mobile',
  name: '移动端',
  component: () => import('../views/mobile/index.vue'),
  children: [
    {
      path: 'home',
      name: '首页',
      component: () => import('../views/mobile/home/index.vue')
    },
    {
      path: 'userInfo',
      name: '个人信息',
      component: () => import('../views/mobile/userInfo/index.vue')
    },
    {
      path: 'message',
      name: '我的消息',
      component: () => import('../views/mobile/message/index.vue')
    },
    {
      path: 'planDetail',
      name: '公告详情',
      component: () => import('../views/mobile/planDetail/index.vue')
    },

  ]
}

const routes = [
  {
    path: '/login',
    component: () => import('../views/login/index.vue')
  },
  {
    path: '/abroadLogin',
    component: () => import('../views/login/abroadLogin.vue')
  },
  {
    path: '/login-online-review',
    component: () => import('../views/login-online-review/index.vue')
  },
  {
    path: '/guide',
    component: () => import('../views/guide/index.vue')
  },
  {
    path: '/demo',
    component: () =>
      import('../views/pages-institution/user-inst/post-apply-inst/require/index.vue')
  },
  {
    path: '/nav',
    component: () => import('../views/demo/nav.vue')
  },
  institutionRoutes,
  personalRoutes,
  onlineReviewRoutes, // 专家在线评审系统
  individualBusinessRoutes, // 个人与企业关系建立
  mobileRoutes, // 移动端路由配置
  // 双百计划
  {
    path: '/dh/innovate-apply-personal',
    name: '双百计划-个人团队创新申报',
    component: () => import('../views/pages-dh/dh-innovate-apply-personal/index.vue'),
  },
  {
    path: '/dh/innovate-apply-overseas',
    name: '海外创赛',
    component: () => import('../views/pages-dh/dh-innovate-apply-personal/index_overseas.vue'),
  },
  {
    path: '/dh/innovate-apply-overseas1',
    name: '海外创赛（企业组）具体必填项参考申报书',
    component: () => import('../views/pages-dh/dh-start-apply-personal/index overseas.vue'),
  },
  {
    path: '/dh/start-apply-personal',
    name: '双百计划-个人团队创业申报',
    component: () => import('../views/pages-dh/dh-start-apply-personal/index.vue')
  },
  {
    path: '/dh/innovate-apply-personal/overseas',
    name: '海外创赛列表',
    component: () => import('../views/pages-personal/index-per/declare-list/components/overseas.vue')
  },
  {
    path: '/dh/innovate-apply-personal/declaration-team',
    name: '双百计划-团队创新申报',
    component: () => import('../views/pages-personal/index-per/declare-list/components/declaration-team.vue')
  },
  {
    path: '/dh/innovate-apply-personal/declaration-personal',
    name: '双百计划-个人创新申报',
    component: () => import('../views/pages-personal/index-per/declare-list/components/declaration-personal.vue')
  },
  // 拔尖人才申报路由配置
  {
    path: '/bajian/apply',
    name: '拔尖人才申报',
    component: () => import('../views/pages-bajian/bajian-apply-personal/index.vue'),  //组件仅用于跳转
  },
  //生物医药
  {
    path: '/biology/apply',
    name: '生物医药申报',
    component: () => import('../views/pages-biology/biology-apply-personal/index.vue'),  //组件仅用于跳转
  },
  // 海外创赛企业组申报路由配置
  {
    path: '/overseas/apply',
    name: '海外创赛企业组申报',
    component: () => import('../views/pages-overseas/overseas-apply-personal/index.vue'),  //组件仅用于跳转
  },
  // 商贸物流人才企业组申报路由配置
  {
    path: '/commerce/apply',
    name: '商贸物流人才申报',
    component: () => import('../views/pages-commerce/commerce-apply-personal/index.vue'),  //组件仅用于跳转
  },
  //金融人才
  {
    path: '/financial/apply',
    name: '金融人才申报',
    component: () => import('../views/pages-financial/financial-apply-personal/index.vue'),  //组件仅用于跳转
  },
  //社会人才
  {
    path: '/social/apply',
    name: '社会人才申报',
    component: () => import('../views/pages-social/social-apply-personal/index.vue'),  //组件仅用于跳转
  },
  //海洋人才
  {
    path: '/ocean/apply',
    name: '海洋人才申报',
    component: () => import('../views/pages-ocean/ocean-apply-personal/index.vue'),  //组件仅用于跳转
  },
   //教育人才
   {
    path: '/education/apply',
    name: '教育人才申报',
    component: () => import('../views/pages-education/education-apply-personal/index.vue'),  //组件仅用于跳转
  },
  //文旅创意人才
  {
    path: '/culturalTourism/apply',
    name: '文旅创意人才申报',
    component: () => import('../views/pages-culturalTourism/culturalTourism-apply-personal/index.vue'),  //组件仅用于跳转
  },
  //卫生健康人才
  {
    path: '/sanitationHealth/apply',
    name: '卫生健康人才申报',
    component: () => import('../views/pages-sanitationHealth/sanitationHealth-apply-personal/index.vue'),  //组件仅用于跳转
  },
  //金融人才证书补贴
  {
    path: '/financialCertificate/apply',
    name: '金融人才证书补贴申报',
    component: () => import('../views/pages-financialCertificate/financialCertificate-apply-personal/index.vue'),  //组件仅用于跳转
  },
];

const router = new Router({
  mode: 'hash',
  routes,
  /* eslint-disable */
  // 跳转的时候滚动到顶部
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});
// 刚启动的时候跳转到ixiamen
router.beforeEach((to, from, next) => {
  if (to.path === '/') {
    if (process.env.NODE_ENV === 'production') {
      // next('/guide');
      window.open(process.env.VUE_APP_IXIAMEN_URL);
    } else {
      //开发环境跳转到个人首页
      next('/nav');
      // next('/login');
    }
  } else {
    next();
  }
});
export default router
